import { gql } from 'apollo-angular';

export var update_has_set_asides = gql`
  mutation UPDATE_HAS_SET_ASIDES($id: ID!, $has_set_asides: Boolean!) {
    updateHasSetAsides(id: $id, has_set_asides: $has_set_asides){
      id, has_set_asides
    }
  }
`;

export var update_project_set_asides = gql`
  mutation UPDATE_PROJECT_SET_ASIDES($input: UpdateProjectSetAsides!) {
    updateProjectSetAsides(input: $input){
      projectSetAsides{
        id, total, is_hard,
        setAsideType{
          id, name
        }
      }
    }
  }
`;

export var update_all_project_set_aside_data = gql`
  mutation UPDATE_ALL_PROJECT_SET_ASIDE_DATA($id: ID!, $has_set_asides: Boolean!, $input: UpdateProjectSetAsides!) {
    updateHasSetAsides(id: $id, has_set_asides: $has_set_asides){
      id, has_set_asides
    },
    updateProjectSetAsides(input: $input){
      projectSetAsides{
        id, total, is_hard,
        setAsideType{
          id, name
        }
      }
    }
  }
`;

export var delete_unit_set_aside = gql`
  mutation DELETE_UNIT_SET_ASIDE($id: ID!) {
    deleteUnitSetAside(id: $id){
      id
    }
  }
`;

export var add_set_aside_type = gql`
  mutation ADD_SET_ASIDE_TYPE($name: String!, $active: Boolean!) {
    addSetAsideType(name: $name, active: $active){
      id, name
    }
  }
`;
